import styled from '@emotion/styled';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useContext } from 'react';

import { themeStyles, themeVars } from '../../theme/theme';
import { useGetData } from '../hooks/useGetData';
import { TableContext } from '../store/store';
import { ActionsToolbar } from './ActionsToolbar';

export const Table = () => {
  const {
    loading,
    columns,
    perPageOptions,
    pagination,
    pageSize,
    page,
    rawDataProps,
    rowHeight,
    headerHeight,
    checkboxSelection,
    sizeStyles,
    defaultSorting,
    toolbar,
    disableColumnMenu,
    disableColumnSorting,
  } = useContext(TableContext);
  const { data, columnVisibilityModel } = useGetData();
  return (
    <Wrapper style={{ ...sizeStyles }}>
      <StyledDataGrid
        loading={loading}
        rows={data}
        columns={columns}
        columnHeaderHeight={headerHeight || 32}
        rowHeight={rowHeight || 40}
        pageSizeOptions={perPageOptions}
        pagination={pagination}
        hideFooter={!pagination}
        resetPageOnSortFilter
        disableColumnSelector={!toolbar?.showColumnSelector}
        disableColumnFilter={!toolbar?.showFilterButton}
        disableDensitySelector
        initialState={{
          filter: {
            filterModel: {
              items: [],
              quickFilterExcludeHiddenColumns: true,
            },
          },
          pagination: {
            paginationModel: {
              pageSize,
              page,
            },
          },
          columns: {
            columnVisibilityModel,
          },
          sorting: {
            sortModel: [...(defaultSorting ? [defaultSorting] : [])],
          },
        }}
        slots={{
          //baseCheckbox: (props) => <TableCheckbox {...props} />,
          toolbar: ActionsToolbar,
        }}
        slotProps={{
          // basePopper: {
          //   placement: 'bottom-start',
          //   modifiers: [
          //     {
          //       name: 'flip',
          //       enabled: true,
          //       options: {
          //         altBoundary: true,
          //         rootBoundary: 'document',
          //         padding: 8,
          //       },
          //     },
          //   ],
          // },
          toolbar: {
            showQuickFilter: toolbar?.showQuickFilter,
          },
          panel: {
            placement: 'top-end',
            popperOptions: {
              modifiers: [
                {
                  name: 'flip',
                  enabled: true,
                  options: {
                    rootBoundary: 'document',
                  },
                },
              ],
            },
          },
        }}
        checkboxSelection={checkboxSelection}
        disableColumnMenu={disableColumnMenu}
        disableColumnSorting={disableColumnSorting}
        disableRowSelectionOnClick
        {...rawDataProps}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDataGrid = styled(DataGridPremium)`
  border: none;
  border-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background-color: #fff;
  font-family: Telka, serif;

  & .MuiDataGrid-row--borderBottom {
    background-color: #f4f5f0 !important;
    color: #181d1f;
    border-bottom: 1px solid #babfc7;
  }

  & .MuiDataGrid-toolbarContainer {
    background-color: #f4f5f0 !important;
    & .MuiButton-root {
      color: #535c61;
    }
  }

  & .MuiDataGrid-root {
    border-bottom: 10px solid #babfc7;
  }

  & .MuiDataGrid-columnHeaderTitle {
    ${themeStyles.text.telka.body.sm};
    color: ${themeVars.colors.coldGrey550};
  }

  & .MuiDataGrid-cell {
    ${themeStyles.text.telka.body.md};
    color: ${themeVars.colors.coldGrey900};
    display: flex;
    align-items: center;
  }

  & .MuiDataGrid-columnHeader {
    padding: 0 16px;
  }

  .MuiDataGrid-columnHeader:focus,
  .MuiDataGrid-columnHeader:focus-within,
  .MuiDataGrid-cell:focus,
  .MuiDataGrid-cell:focus-within {
    outline: none;
  }
`;
